import { Switch } from '@material-ui/core';
import './toggleTabs.scss';

export const OFF = 'off';
export const ON = 'on';

export interface SwitchProps {
    value: 'off' | 'on';
    onText: '';
    offText: '';
}
export default function ToggleTabs({
    value = 'off',
    onText = 'Sign In Via Password',
    offText = 'Sign In Via OTP',
    extraClass = '',
    disabled = false,
    ...props
}: SwitchProps & any) {
    return (
        <div className={`toggle-tabs ${extraClass}`}>
            <a
                onClick={() => props.updateValue({ target: { checked: false } })}
                className={value === OFF ? 'active' : ''}
            >
                {offText}
            </a>
            <div className="toggle">
                <Switch
                    disabled={disabled}
                    value={value}
                    checked={value === ON}
                    onChange={props.updateValue}
                    name="signInToggle"
                    inputProps={{ 'aria-label': 'toggleSwitch' }}
                />
            </div>
            <a
                onClick={() => props.updateValue({ target: { checked: true } })}
                className={value === ON ? 'active' : ''}
            >
                {onText}
            </a>
        </div>
    );
}
